import { createContext, useContext } from 'react';
export const SidePanelLayoutContext = /*#__PURE__*/createContext({
  currentStepNumber: 0,
  totalSteps: 0
});
export const useSidePanelLayoutContext = () => {
  const context = useContext(SidePanelLayoutContext);
  if (context === undefined) {
    throw new Error('This component must be used within a SidePanelLayout.Root component');
  }
  return context;
};